import { Section } from '../../style/section';
import styled from 'styled-components';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { theme } from '../../style/theme';

const { colors } = theme;

export const StyledContainer = styled(Section)`
    position: realtive;

`;

export const StyledFlexContainer = styled.div`
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
`;


export const StyledPagination = styled(Pagination)`
    &.page-item{
        background: ${colors.bg} !important;
        border: none !important;
        color: ${colors.lightSlate} !important;  
    }

`;

export const StyledPaginationItem = styled(PaginationItem)`
   &.active{
            button {
                background:  ${colors.secondary} !important;
            }
        }
    
`;

export const StyledPaginationLink = styled(PaginationLink)`
    background: ${colors.bg} !important;
    border: none !important;
    color: ${colors.lightSlate} !important; 
    margin: 20px auto !important;  
`;